import XiaomiLogo from "../../assets/img/grupos/Xiaomi.png";
import SamsungLogo from "../../assets/img/grupos/Samsung.png";
import MotorolaLogo from "../../assets/img/grupos/Motorola.png";
import AppleLogo from "../../assets/img/grupos/Apple.png";
import GeralLogo from "../../assets/img/grupos/Geral.png";
import HiperfocoLogo from "../../assets/img/grupos/hiperfoco.png";

const configs = {
  ofertas: {
    tipo: "ofertas",
    titulo: "GERAIS",
    subtitulo: "Produtos pela <b>METADE DO PREÇO</b> ⚡",
    imagem: GeralLogo,
    selo: "JERSU INDICA OFERTAS",
    wppIcon: true,
  },
  celular: {
    tipo: "celular",
    titulo: "CELULAR",
    subtitulo: "As melhores promoções de <b>celulares</b> 📱",
    cor: "#0e7a4a",
    selo: "JERSU INDICA CELULAR",
    wppIcon: true,
  },
  xiaomi: {
    tipo: "xiaomi",
    titulo: "XIAOMI",
    subtitulo: "Promoções exclusivas de <b>Xiaomi</b> ⚡",
    imagem: XiaomiLogo,
    selo: "JERSU INDICA XIAOMI",
    wppIcon: true,
  },
  samsung: {
    tipo: "samsung",
    titulo: "SAMSUNG",
    subtitulo: "Promoções exclusivas de <b>Samsung</b> 📱",
    imagem: SamsungLogo,
    selo: "JERSU INDICA SAMSUNG",
    wppIcon: true,
  },
  motorola: {
    tipo: "motorola",
    titulo: "MOTOROLA",
    subtitulo: "Promoções exclusivas de <b>Motorola</b> 📱",
    imagem: MotorolaLogo,
    selo: "JERSU INDICA MOTOROLA",
    wppIcon: true,
  },
  apple: {
    tipo: "apple",
    titulo: "APPLE",
    subtitulo: "Promoções exclusivas de <b>Apple</b> 🍎",
    imagem: AppleLogo,
    selo: "JERSU INDICA APPLE",
    wppIcon: true,
  },
  hiperfoco: {
    tipo: "hiperfoco",
    titulo: "HIPERFOCO",
    subtitulo: "Ofertas com <b>foco total</b> pra você 🎯",
    imagem: HiperfocoLogo,
    cor: "#e91e63",
    selo: "JERSU INDICA HIPERFOCO",
    wppIcon: true,
  },
  perfumes: {
    tipo: "perfumes",
    titulo: "PERFUMES",
    subtitulo: "Fragrâncias com <b>preço de verdade</b> ✨",
    cor: "#c2185b",
    selo: "JERSU INDICA PERFUMES",
    wppIcon: true,
  },
};

export default configs;
